// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2g9rE","image":"styles__image___2Eh6l","title":"styles__title___1i9IG","big":"styles__big____ZNuB styles__title___1i9IG"};